import { Component } from '@angular/core';
import { NavController, NavParams } from 'ionic-angular';
import { FormBuilder } from '@angular/forms';
import { Globals } from "../../../../globals";
import { ConfigurationServices } from "../../services";
import { TranslateService } from '@ngx-translate/core';
import { HttpClient } from '@angular/common/http';

/**
 * Generated class for the ConfigurationPaymentPayplazaPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@Component({
  selector: 'page-configuration-payment-payplaza',
  templateUrl: 'configuration-payment-payplaza.html',
})
export class ConfigurationPaymentPayplazaPage {

  constructor(public navCtrl: NavController,
    public navParams: NavParams,
    public fb: FormBuilder,
    public configurationServices: ConfigurationServices,
    public globals: Globals,
    public translate: TranslateService,
    private http: HttpClient,
    ) {

        //notificacion de interes sobre el pay
        if(!this.globals.restaurant.payment_method_payplaza || this.globals.restaurant.payment_method_payplaza){
          this.notificationSlack();
        }
  }

  changePayplaza(active){
    this.configurationServices.afs.collection('restaurants').doc(this.globals.restaurant_uid).update({
      'payment_method_payplaza': active
    }).then(() => {
      this.globals.restaurant.payment_method_payplaza = active;
    });
  }


  async notificationSlack() {
    var msg = 'El usuario ' + this.globals.restaurant.company + ', ' + this.globals.restaurant.name + ' (' + this.globals.restaurant.email + ') ha abierto el config de Pay CM.com.';

    //send
    await this.http.post(this.globals.api_path + 'slack/integrations', {
      msg: msg,
    }, {}).subscribe(async data => {
    },
      err => {}
    );
  }

}



// WEBPACK FOOTER //
// ./src/pages/configuration/configuration-payment-methods/configuration-payment-payplaza/configuration-payment-payplaza.ts